import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestForm.standalone.MainSection', {
    nameLabel: 'Name',
    namePlaceholder: 'Write a short subject',
    amountLabel: 'Amount',
    amountPlaceholder: 'Set an amount',
    currencyLabel: 'Currency',
    currencyPlaceholder: 'Choose',
    dateLabel: 'Date',
    datePlaceholder: 'Enter date',
});
